import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckinBaseComponent } from '@common/components';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-checkin-completed-sub-header',
  templateUrl: './checkin-completed-sub-header.component.html',
  styleUrls: ['./checkin-completed-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinCompletedSubHeaderComponent extends CheckinBaseComponent {
  /** ページタイトル */
  pageTitle?: string;

  constructor(commonService: CommonLibService) {
    super(commonService);
  }

  override reload(): void {}
  override init(): void {}
  override destroy(): void {}
}
